/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */
// @ts-nocheck

import { types } from 'mobx-state-tree'
import { QueryBuilder } from 'mst-gql'
import { ModelBase } from './ModelBase'
import { RootStoreType } from './index'

/**
 * PlayerGroupBase
 * auto generated base class for the model PlayerGroupModel.
 */
export const PlayerGroupModelBase = ModelBase.named('PlayerGroup')
  .props({
    __typename: types.optional(types.literal('PlayerGroup'), 'PlayerGroup'),
    date: types.union(types.undefined, types.string),
    observers: types.union(types.undefined, types.array(types.string)),
    players: types.union(types.undefined, types.array(types.string))
  })
  .views((self) => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class PlayerGroupModelSelector extends QueryBuilder {
  get date() {
    return this.__attr('date')
  }
  get observers() {
    return this.__attr('observers')
  }
  get players() {
    return this.__attr('players')
  }
}
export function selectFromPlayerGroup() {
  return new PlayerGroupModelSelector()
}

export const playerGroupModelPrimitives = selectFromPlayerGroup().date.observers.players
